import { render, staticRenderFns } from "./MaterialPicker.vue?vue&type=template&id=92d0a58e&scoped=true"
import script from "./MaterialPicker.vue?vue&type=script&lang=js"
export * from "./MaterialPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d0a58e",
  null
  
)

export default component.exports